import { createBrowserRouter } from "react-router-dom";
import Home  from "./pages/Home";
import { homeLoader } from "./component/FilterPage";
 
const router = createBrowserRouter([
  {
    path: "/:id?/:id2?/:id3?",
    element: <Home />,
    loader: homeLoader,
  },
   
]);

export default router;
